var map = {
	"./axe_1.png": "4723",
	"./axe_2.png": "92d7",
	"./axe_3.png": "b3bd",
	"./axe_4.png": "47fc",
	"./axe_5.png": "57b2",
	"./axe_6.png": "d44e5",
	"./bow_1.png": "4259",
	"./bow_2.png": "f675",
	"./bow_3.png": "ffd6",
	"./bow_4.png": "08292",
	"./bow_5.png": "5ebd",
	"./bow_6.png": "37e1",
	"./bow_7.png": "5346",
	"./bow_8.png": "18fd",
	"./club_1.png": "39aa",
	"./club_2.png": "5bdd",
	"./crossbow_1.png": "c424",
	"./crossbow_2.png": "25ba",
	"./dagger_1.png": "a658",
	"./dagger_2.png": "ba00",
	"./dagger_3.png": "a093",
	"./dagger_4.png": "3831",
	"./dagger_5.png": "e262",
	"./dagger_6.png": "d2a5",
	"./dart_1.png": "3f69",
	"./dart_2.png": "5646",
	"./flail_1.png": "0393",
	"./hammer_1.png": "2bfa",
	"./hammer_2.png": "9007",
	"./maul_1.png": "438a",
	"./morningstar_1.png": "316b",
	"./polearm_1.png": "d0c7",
	"./polearm_2.png": "f915",
	"./polearm_3.png": "9445",
	"./quarterstaff_1.png": "b456",
	"./quarterstaff_2.png": "f006",
	"./scythe_1.png": "35ff",
	"./sickle_1.png": "1517",
	"./sickle_2.png": "8ef1",
	"./sickle_3.png": "5cae",
	"./sickle_4.png": "f43b",
	"./sling_1.png": "04f9",
	"./spear_1.png": "aa31",
	"./spear_2.png": "c2d3",
	"./spear_3.png": "a3aa",
	"./sword_1.png": "b192",
	"./sword_10.png": "a015",
	"./sword_11.png": "e84d",
	"./sword_12.png": "4e8f",
	"./sword_13.png": "f92e",
	"./sword_14.png": "6f0f",
	"./sword_15.png": "e673",
	"./sword_2.png": "6de2",
	"./sword_3.png": "4539",
	"./sword_4.png": "749e",
	"./sword_5.png": "7f0b",
	"./sword_6.png": "d144",
	"./sword_7.png": "1323",
	"./sword_8.png": "bbe2",
	"./sword_9.png": "7c69",
	"./trident_1.png": "931f",
	"./whip_1.png": "8270"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4963";